import { render, staticRenderFns } from "./term-free-ferry.vue?vue&type=template&id=0be0a0fe&"
import script from "./term-free-ferry.vue?vue&type=script&lang=js&"
export * from "./term-free-ferry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports